import "./App.css";
import logo from "../src/Assets/logo.png";

function App() {
  return (
    <div className="page">
      <div className="text-block">
        <img src={logo} alt="The Amara Bridge Logo" className="logo" />

        <h1>The Amara Bridge</h1>
        <h2>Launching Soon...</h2>
        <p>We’re working on something special. Stay tuned!</p>
      </div>
    </div>
  );
}

export default App;
